import { createAction } from 'redux-actions';

import { generateApiActions } from './action-helpers';

const types = {
  FETCH_USERS: 'FETCH_USERS',
  DELETE_USER: 'DELETE_USER',
  RESTORE_USER: 'RESTORE_USER',
  CHANGE_USER_ROLE: 'CHANGE_USER_ROLE',
};

export const {
  fetchUsersRequest,
  fetchUsersSuccess,
  fetchUsersFailure,
} = generateApiActions(types.FETCH_USERS);

export const deleteUser = createAction(types.DELETE_USER);
export const restoreUser = createAction(types.RESTORE_USER);
export const changeUserRole = createAction(types.CHANGE_USER_ROLE);



// WEBPACK FOOTER //
// ./src/redux/actions/users.js